<template>
  <div class="coming-soon">
    <div class="coming-soon-icon">🏛️</div>
    <h2 class="coming-soon-title">东亚同文会本部人员名录</h2>
    <p class="coming-soon-text">
      本部分将提供东亚同文会本部工作人员的详细名录及相关历史资料。
      正在积极准备中，即将与您见面！
    </p>
  </div>
</template>

<script>
export default {
  name: 'Personnel'
}
</script>

<style scoped>
.coming-soon {
  text-align: center;
  padding: 50px 20px;
}

.coming-soon-icon {
  font-size: 5rem;
  color: var(--primary-color);
  margin-bottom: 20px;
}

.coming-soon-title {
  font-size: 1.8rem;
  color: var(--primary-dark);
  margin-bottom: 15px;
}

.coming-soon-text {
  font-size: 1.1rem;
  color: var(--secondary-color);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .coming-soon-icon {
    font-size: 3.5rem;
  }

  .coming-soon-title {
    font-size: 1.5rem;
  }

  .coming-soon-text {
    font-size: 1rem;
  }
}
</style>